import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/* eslint-disable  @typescript-eslint/no-explicit-any */
import { isEmpty } from 'ramda';
import { loadYmapsApi } from './ymaps';
import { mcsNames } from '../constants/mcsNames';
import { YandexMonitor, YandexScriptError } from './yandexMonitor';
export function getMultiSuggest(_x) {
  return _getMultiSuggest.apply(this, arguments);
}

function _getMultiSuggest() {
  _getMultiSuggest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _params$yandex, value, apiKey, suggestApiKey, targetPage, yaSuggestResult, suggestions, mcsName, yandexSuggestApi, yMonitor;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _params$yandex = params.yandex, value = _params$yandex.value, apiKey = _params$yandex.apiKey, suggestApiKey = _params$yandex.suggestApiKey, targetPage = params.targetPage;
            yaSuggestResult = null;
            suggestions = {};
            mcsName = mcsNames[targetPage];
            _context.next = 6;
            return loadYmapsApi({
              require: ['suggest']
            }, apiKey, suggestApiKey);

          case 6:
            yandexSuggestApi = _context.sent;
            yMonitor = new YandexMonitor({
              isStrict: true,
              mcsName: mcsName
            });
            _context.prev = 8;
            _context.next = 11;
            return yandexSuggestApi.suggest("\u0420\u043E\u0441\u0441\u0438\u044F, ".concat(value));

          case 11:
            yaSuggestResult = _context.sent;

            if (!('message' in yaSuggestResult)) {
              _context.next = 14;
              break;
            }

            throw new YandexScriptError();

          case 14:
            yMonitor.sendTelemetryCounter();
            yMonitor.sendTelemetryTimer();
            _context.next = 22;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](8);
            yMonitor.log(_context.t0);
            throw _context.t0;

          case 22:
            if (!isEmpty(yaSuggestResult)) {
              suggestions.addresses = yaSuggestResult;
            }

            return _context.abrupt("return", {
              suggestions: suggestions,
              sortOrder: ['addresses']
            });

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[8, 18]]);
  }));
  return _getMultiSuggest.apply(this, arguments);
}